import {
  required,
  TextInput,
  SimpleForm,
  SelectInput,
  BooleanInput,
  NumberInput,
} from "react-admin";

const validateRequired = [required()];

const categoryChoices = [
  { id: "candidate_dropout", name: "resources.job-application-closure-reason.categoryChoices.candidate_dropout" },
  { id: "candidate_decision", name: "resources.job-application-closure-reason.categoryChoices.candidate_decision" },
  { id: "company_decision", name: "resources.job-application-closure-reason.categoryChoices.company_decision" },
];

const phaseChoices = [
  { id: "pre_hire", name: "resources.job-application-closure-reason.phaseChoices.pre_hire" },
  { id: "post_hire", name: "resources.job-application-closure-reason.phaseChoices.post_hire" },
];

export const JobApplicationClosureReasonForm = (props: any) => (
  <SimpleForm warnWhenUnsavedChanges {...props}>
    <TextInput source="name" validate={validateRequired} fullWidth />
    <SelectInput source="category" choices={categoryChoices} validate={validateRequired} fullWidth />
    <SelectInput source="phase" choices={phaseChoices} validate={validateRequired} fullWidth />
    <BooleanInput source="isActive" defaultValue={true} />
    <NumberInput source="order" defaultValue={0} fullWidth />
  </SimpleForm>
);

export { JobApplicationClosureReasonList } from './List';
export { JobApplicationClosureReasonCreate } from './Create';
export { JobApplicationClosureReasonEdit } from './Edit';
export { JobApplicationClosureReasonIcon } from './Icon';
